module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsMother@2x.d7363cb.jpg";